/**
 * The round tiebreaker guess (ISSUE-1309): the combined final score of the
 * round's last game, named by the server (`round-get.tiebreaker`). Editable
 * until that game kicks off, then shown read only. Empty clears the guess.
 */
import { Input } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  PICKEM_TIEBREAKER_HEADING,
  PICKEM_TIEBREAKER_HINT,
  PICKEM_TIEBREAKER_LOCKED_NONE,
  PICKEM_TIEBREAKER_RANGE_ERROR,
  pickemTiebreakerGameLine,
} from "./pickemCopy";
import type { typePickemTiebreaker } from "./pickemTypes";

export const PickemTiebreakerField = (props: {
  tiebreaker: typePickemTiebreaker;
  gameLabel: string;
  text: string;
  isInvalid: boolean;
  disabled: boolean;
  onChangeText: (text: string) => void;
}): ReactNode => {
  const label = pickemTiebreakerGameLine(props.gameLabel);
  return (
    <section
      className="flex flex-col gap-2 rounded-md border border-hairline bg-surface p-3"
      data-testid="pickem-tiebreaker"
    >
      <h2 className="text-body-strong text-ink">{PICKEM_TIEBREAKER_HEADING}</h2>
      {props.tiebreaker.isLocked ? (
        <p
          className="text-body text-ink"
          data-testid="pickem-tiebreaker-locked"
        >
          {label}:{" "}
          <span className="font-semibold tabular-nums">
            {typeof props.tiebreaker.myGuess === "number"
              ? props.tiebreaker.myGuess
              : PICKEM_TIEBREAKER_LOCKED_NONE}
          </span>
        </p>
      ) : (
        <Input
          label={label}
          hint={PICKEM_TIEBREAKER_HINT}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={3}
          autoComplete="off"
          value={props.text}
          disabled={props.disabled}
          error={props.isInvalid ? PICKEM_TIEBREAKER_RANGE_ERROR : undefined}
          onChange={(event) => {
            props.onChangeText(event.target.value);
          }}
          data-testid="pickem-tiebreaker-input"
        />
      )}
    </section>
  );
};
